<div class="columns is-multiline">
    <div class="column is-full">
        <grt-body-header>About GrETEL</grt-body-header>
    </div>
    <div class="column is-full">
        <grt-about-content></grt-about-content>
    </div>
</div>
